import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Event } from "@circle-react/types";
import { Header, useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { isDraft, isRecurring } from "../../utils";
import { SubmitEditButton } from "../SubmitEditButton";
import { PreviewEventLink } from "./PreviewEventLink";

interface ActionsProps {
  className?: string;
  event: Event | null;
  onPublish: (edit_mode: any) => void;
}

export const Actions = ({ event, onPublish, className }: ActionsProps) => {
  const { isSaving } = useCustomizeUIData();

  const isEventDraft = isDraft(event);

  return (
    <Header.Actions
      className={classNames(
        "justify-between px-5 pb-6 pt-2 md:justify-end md:p-0",
        className,
      )}
    >
      {event && <PreviewEventLink event={event} isEventDraft={isEventDraft} />}
      {isEventDraft && (
        <SubmitEditButton
          variant="circle"
          disabled={isSaving}
          onEditModeConfirm={onPublish}
          isRecurringEvent={isRecurring(event)}
          isPublishing
        >
          {t("events.edit_modal.buttons.publish")}
        </SubmitEditButton>
      )}
    </Header.Actions>
  );
};
